// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "quickbooks.proto" (syntax proto3)
// tslint:disable
import { QuickBooksService } from "./quickbooks";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service QuickBooksService
 */
export class QuickBooksServiceClient {
    constructor(_transport) {
        this._transport = _transport;
        this.typeName = QuickBooksService.typeName;
        this.methods = QuickBooksService.methods;
        this.options = QuickBooksService.options;
    }
    /**
     * OAuth operations
     *
     * @generated from protobuf rpc: GetAuthURL
     */
    getAuthURL(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ExchangeCode
     */
    exchangeCode(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: RefreshToken
     */
    refreshToken(input, options) {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Health check
     *
     * @generated from protobuf rpc: GetHealthStatus
     */
    getHealthStatus(input, options) {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Item discovery & mapping
     *
     * @generated from protobuf rpc: DiscoverQBOItems
     */
    discoverQBOItems(input, options) {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateItemMapping
     */
    createItemMapping(input, options) {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListItemMappings
     */
    listItemMappings(input, options) {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteItemMapping
     */
    deleteItemMapping(input, options) {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Customer discovery & mapping
     *
     * @generated from protobuf rpc: ListQBOCustomers
     */
    listQBOCustomers(input, options) {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateCustomerMapping
     */
    createCustomerMapping(input, options) {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListCustomerMappings
     */
    listCustomerMappings(input, options) {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteCustomerMapping
     */
    deleteCustomerMapping(input, options) {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Class discovery & mapping (department → QBO class)
     *
     * @generated from protobuf rpc: DiscoverQBOClasses
     */
    discoverQBOClasses(input, options) {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateClassMapping
     */
    createClassMapping(input, options) {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListClassMappings
     */
    listClassMappings(input, options) {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteClassMapping
     */
    deleteClassMapping(input, options) {
        const method = this.methods[15], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Invoice void
     *
     * @generated from protobuf rpc: VoidInvoice
     */
    voidInvoice(input, options) {
        const method = this.methods[16], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Payment terms backfill: set SalesTermRef on already-synced QBO customers
     * from userz.user_billingTerms (dry_run reports without writing).
     *
     * @generated from protobuf rpc: BackfillCustomerSalesTerms
     */
    backfillCustomerSalesTerms(input, options) {
        const method = this.methods[17], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
